<template>
  <div class="mixing-search-wrap">
    <!-- D: 상세검색 -->
    <form action="">
      <div class="c-board-write">
        <!-- <div class="tr">
          <div class="th">일반/팬톤</div>
          <div class="td">
            <div class="c-filter-box type-non-line">
              <div class="c-check-field">
                <div class="c-radio type-small type-small">
                  <input
                    type="radio"
                    id="radio1-1"
                    name="radio01Group"
                    v-model="data.colorCombin.search.prdctSeCd"
                    value=""
                    checked
                    @click="searchCmd('radio01Chk', { type: '' })"
                  />
                  <label for="radio1-1">전체</label>
                </div>
                <div class="c-radio type-small">
                  <input
                    type="radio"
                    id="radio1-2"
                    name="radio01Group"
                    v-model="data.colorCombin.search.prdctSeCd"
                    value="G"
                    @click="searchCmd('radio01Chk', { type: 'G' })"
                  />
                  <label for="radio1-2">일반</label>
                </div>
                <div class="c-radio type-small">
                  <input
                    type="radio"
                    id="radio1-3"
                    name="radio01Group"
                    v-model="data.colorCombin.search.prdctSeCd"
                    value="P"
                    @click="searchCmd('radio01Chk', { type: 'P' })"
                  />
                  <label for="radio1-3">팬톤</label>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="tr">
          <div class="th">제품명</div>
          <div class="td">
            <div class="c-filter-box type-non-line">
              <div class="c-check-field">
                <div class="c-radio type-small">
                  <input
                    type="radio"
                    id="radio2-1"
                    name="radio02Group"
                    v-model="data.colorCombin.search.pntSeCd"
                    value=""
                    checked
                    @click="searchCmd('radio02Chk', { type: '' })"
                  />
                  <label for="radio2-1">전체</label>
                </div>
                <div class="c-radio type-small">
                  <input
                    type="radio"
                    id="radio2-2"
                    name="radio02Group"
                    v-model="data.colorCombin.search.pntSeCd"
                    value="WATER"
                    @click="searchCmd('radio02Chk', { type: 'WATER' })"
                  />
                  <label for="radio2-2">수성</label>
                </div>
                <div class="c-radio type-small">
                  <input
                    type="radio"
                    id="radio2-3"
                    name="radio02Group"
                    v-model="data.colorCombin.search.pntSeCd"
                    value="OIL"
                    @click="searchCmd('radio02Chk', { type: 'OIL' })"
                  />
                  <label for="radio2-3">유성</label>
                </div>
              </div>
              <div class="c-select">
                <select v-model="data.colorCombin.search.chcPrdctSn">
                  <option value="null">선택하세요</option>
                  <option
                    v-for="(item, idx) in data.selectBox.list"
                    :key="idx"
                    :value="item.chcPrdctSn"
                  >
                    {{ item.prdctNm }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="tr">
          <div class="th">등록일</div>
          <div class="td">
            <div class="form-layout">
              <div class="c-form-field">
                <label class="c-input-calender">
                  <input
                    type="text"
                    required
                    id="startDate"
                    title="시작일"
                    data-datepicker
                    ref="startDatepickerRef"
                    v-model="data.colorCombin.search.startRegDt"
                    readonly
                  />
                </label>
                <span class="tilde">~</span>
                <label class="c-input-calender">
                  <input
                    type="text"
                    required
                    id="endDate"
                    title="종료일"
                    data-datepicker
                    ref="endDatepickerRef"
                    v-model="data.colorCombin.search.endRegDt"
                    readonly
                  />
                </label>
              </div>
              <div class="c-round-button-box">
                <div class="c-radio-round type-black">
                  <input
                    type="radio"
                    id="filter-date-option5-1"
                    name="filter-date-option5"
                    @change="dateCalculation('ALL')"
                    value="ALL"
                    v-model="data.colorCombin.chkDate"
                  />
                  <label for="filter-date-option5-1">전체</label>
                </div>
                <div class="c-radio-round type-black">
                  <input
                    type="radio"
                    id="filter-date-option5-2"
                    name="filter-date-option5"
                    @change="dateCalculation('1M')"
                    value="1M"
                    v-model="data.colorCombin.chkDate"
                  />
                  <label for="filter-date-option5-2">1개월</label>
                </div>
                <div class="c-radio-round type-black">
                  <input
                    type="radio"
                    id="filter-date-option5-3"
                    name="filter-date-option5"
                    @change="dateCalculation('6M')"
                    value="6M"
                    v-model="data.colorCombin.chkDate"
                  />
                  <label for="filter-date-option5-3">6개월</label>
                </div>
                <div class="c-radio-round type-black">
                  <input
                    type="radio"
                    id="filter-date-option5-4"
                    name="filter-date-option5"
                    checked
                    @change="dateCalculation('1Y')"
                    value="1Y"
                    v-model="data.colorCombin.chkDate"
                  />
                  <label for="filter-date-option5-4">1년</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tr">
          <div class="th">제품명</div>
          <div class="td">
                <label class="c-input-calender">
                <input
                  type="text"
                  class="search-input"
                  id="startDate"
                  v-model="data.colorCombin.search.prdctNm"
                />
              </label>
          </div>
          <div class="th">광택</div>
          <div class="td">
                <label class="c-input-calender">
                <input
                  type="text"
                  class="search-input"
                  id="startDate"
                  v-model="data.colorCombin.search.shineTypeNm"
                />
              </label>
          </div>
          <div class="th">컬러북</div>
          <div class="td">
                <label class="c-input-calender">
                <input
                  type="text"
                  class="search-input"
                  id="startDate"
                  v-model="data.colorCombin.search.colorBookNm"
                />
              </label>
          </div>
        </div>

        <div class="tr">
          <div class="th">색상명</div>
          <div class="td">
                <label class="c-input-calender">
                <input
                  type="text"
                  class="search-input"
                  id="startDate"
                  v-model="data.colorCombin.search.colorNm"
                />
              </label>
          </div>
          <div class="th">작성자</div>
          <div class="td">
                <label class="c-input-calender">
                <input
                  type="text"
                  class="search-input"
                  id="startDate"
                  v-model="data.colorCombin.search.rgtr"
                />
              </label>
          </div>
          <div class="th">글번호</div>
          <div class="td">
                <label class="c-input-calender">
                <input
                  type="text"
                  class="search-input"
                  id="startDate"
                  v-model="data.colorCombin.search.cybSeqNo"
                />
              </label>
          </div>
        </div>

        <div class="tr">
          <div class="th">
            조색배합검색
            <!--
                      D: popover 버튼(PC전용)
                      1. 오픈할 클릭 요소에 data-popover-trigger={값} 추가
                      2. 주의사항: 다른 상품이나 요소들에 값이 동일하면 동작이 안합니다.
                    -->
            <button
              type="button"
              class="btn-popover"
              data-popover-trigger="delivery1"
            >
              <i class="c-icon icon-question size-medium"></i>
            </button>
            <!--
                      D: popover 상세(PC전용)
                      1. 오픈시 상세 요소에 data-popover="{값}"
                      2. 클릭시 is-active 추가 ui_app.js에 스크립트 가이드작성함
                    -->
            <div class="c-popover-detail" data-popover="delivery1">
              <div class="text">배합 답변 DB 기반 검색</div>
            </div>
          </div>
          <div class="td">
            <!--
                      D.
                      1. data-layer-hidden 속성 존재시 단순 검색 케이스로 바뀜
                      2. data-search-ui는 뒤늦게 추가된 공통 검색 ui를 동작하기위한 속성
                    -->
            <div class="c-filter-search" data-search-ui data-layer-hidden>
              <div class="search-form">
                <label class="sr-only">조색배합검색</label>
                <input
                  type="search"
                  id="searchQuery"
                  title="검색"
                  class="search-input"
                  autocomplete="off"
                  placeholder="제품명, 색상명 등 키워드 입력"
                  v-model="data.colorCombin.search.searchKeyword"
                  value=""
                  @keyup.enter="searchCmd('search', {})"
                />
                <button
                  type="button"
                  class="search-cancel"
                  @click="resetCmd('keyword')"
                >
                  <i class="c-icon icon-large-x"></i>
                  <span class="sr-only">검색어 재입력</span>
                </button>
                <button
                  type="button"
                  class="search-submit"
                  @click="searchCmd('search', {})"
                >
                  <span class="sr-only">검색</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- // D: 상세검색 -->
    <!-- D: 상세 검색 버튼 -->
    <div class="c-btn-area has-mixing-submit">
      <button
        type="button"
        class="c-util-button type-line-black"
        @click="resetCmd('reset')"
      >
        <span>초기화</span>
      </button>
      <button
        type="button"
        class="c-util-button type-primary"
        @click="searchCmd('search', {})"
      >
        <span>조회</span>
      </button>
    </div>
    <!-- // D: 상세 검색 버튼 -->

    <!-- D: tabs -->
    <div class="c-square-tabs">
      <ul>
        <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
        <li class="tab-item">
          <button
            type="button"
            id="tabType"
            :class="data.tabType ? 'tab-anchor is-active' : 'tab-anchor'"
            role="tab"
            :aria-selected="data.tabType ? true : false"
            @click.stop="tabActive"
          >
            전체문의
          </button>
        </li>
        <li class="tab-item">
          <button
            type="button"
            id="isTab2"
            :class="data.tabType ? 'tab-anchor' : 'tab-anchor is-active'"
            role="tab"
            :aria-selected="data.tabType ? false : true"
            @click.stop="tabActive"
          >
            MY배합
          </button>
        </li>
      </ul>
      <a
        href="#"
        class="c-util-button type-primary"
        @click="moveToCombinInqTab"
      >
        <span>배합문의</span>
      </a>
    </div>

    <!-- D: 문의 검색 목록 -->
    <div class="c-notice-list type-mixing" data-accordion-wrap>
      <div class="head">
        <div class="th" style="--tb-width: 7%">NO</div>
        <div v-if="data.colorCombin.flag" class="th" style="--tb-width: 7%">사이버샵번호</div>
        <div class="th" style="--tb-width: 7.5%">일반/팬톤</div>
        <div class="th" style="--tb-width: 7%">수유성</div>
        <div class="th" style="--tb-width: 216px">제품명</div>
        <div class="th" style="--tb-width: 7%">베이스</div>
        <div class="th" style="--tb-width: 6%">광택</div>
        <div class="th" style="--tb-width: 7%">컬러북</div>
        <div class="th" style="--tb-width: 9%">색상명</div>
        <div class="th" style="--tb-width: 7%">규격</div>
        <div class="th" style="--tb-width: 8%">답변여부</div>
        <div class="th" style="--tb-width: 9%">등록일</div>
        <div class="th" style="--tb-width: 6%">펼침</div>
      </div>
      <div class="body">
        <!-- D: 답변 등록전(button에 disabled추가+토스트팝업 활성화 is-active 클래스 추가) -->
        <div
          class="item"
          v-for="(item, idx) in data.colorCombin.list"
          :key="idx"
          :id="'ID' + item.combnCrcolnQstnSn"
        >
          <button
            type="button"
            class="accordion-button"
            data-accordion-trigger
            :aria-expanded="data.colorCombin.expendIndex === idx"
            :aria-controls="'act' + idx"
            @click="
              btnCmd('expendClick', {
                index: idx,
                baseCd: item.baseCd,
                combnCrtrVol: item.combnCrtrVol,
                pntSn: item.pntSn,
                spcfctCd: item.spcfctCd,
                combnCrcolnQstnSn: item.combnCrcolnQstnSn,
                ansRemarkCn: item.ansRemarkCn,
                clickType: 'list',
              })
            "
          >
            <div style="display: none">
              파람sn {{ data.route.combnCrcolnQstnSn }} | 펼침인덱스:{{
                data.colorCombin.expendIndex
              }}
              | 행sn{{ item.combnCrcolnQstnSn }} |
            </div>
            <!-- D: PC 전용 -->
            <div class="only-pc">
              <div class="td" style="--tb-width: 7%">
                <span class="number">{{ item.combnCrcolnQstnSn }}</span>
              </div>
              <div v-if="data.colorCombin.flag" class="td" style="--tb-width: 7%">
                <span v-if="item.cybSeqNo==0" >-</span>
                <span v-if="item.cybSeqNo!=0" >{{ item.cybSeqNo }}</span>
              </div>
              <div class="td" style="--tb-width: 7.5%">
                <span class="type">{{ item.prdctSeNm }}</span>
              </div>
              <div class="td" style="--tb-width: 7%">
                <!-- 수성/유성-->
                <span class="coating">{{ item.pntSeNm }}</span>
              </div>
              <div class="td al" style="--tb-width: 216px">
                <!-- 제품명 -->
                <strong class="title">{{ item.prdctNm }}</strong>
              </div>
              <div class="td" style="--tb-width: 7%">
                <!-- 베이스 -->
                <span class="base">{{ item.baseNm }}</span>
              </div>
              <div class="td" style="--tb-width: 6%">
                <!-- 광택 -->
                <span class="gloss">{{ item.shineTypeNm }}</span>
              </div>
              <div class="td" style="--tb-width: 7%">
                <!-- 컬러북 -->
                <span class="gloss">{{ cmUtil.sanitizeHTML2(item.colorBookNm) }}</span>
              </div>
              <div class="td" style="--tb-width: 9%">
                <!-- 컬러명 -->
                <span class="color-name">{{ cmUtil.sanitizeHTML2(item.colorNm) }}</span>
              </div>
              <div class="td" style="--tb-width: 7%">
                <!-- 규격 -->
                <span class="standard" v-if="item.oldYn != 'Y'">{{ item.spcfctNm }}</span>
                <span class="standard" v-else>{{ item.spcfctInputCn }}</span>
              </div>
              <div class="td" style="--tb-width: 8%">
                <span class="answer-status">
                  <span
                    :class="
                      item.ansRemarkCn != null
                        ? 'c-flag type-answer type-primary'
                        : 'c-flag type-answer type-gray'
                    "
                    >{{
                      item.ansRemarkCn != null ? "답변완료" : "답변대기"
                    }}</span
                  >
                </span>
                <span class="c-flag type-answer type-delete" v-if="item.ansRemarkCn== null && !data.tabType" 
                @click.stop="
                btnCmd('expendClick', {
                  index: idx,
                  baseCd: item.baseCd,
                  combnCrtrVol: item.combnCrtrVol,
                  pntSn: item.pntSn,
                  spcfctCd: item.spcfctCd,
                  combnCrcolnQstnSn: item.combnCrcolnQstnSn,
                  ansRemarkCn: item.ansRemarkCn,
                  clickType: 'list-delete',
                })
              "
                >문의삭제</span>
              </div>
              <div class="td" style="--tb-width: 9%">
                <!-- 작성자 등록일 -->
                <span class="date">{{ item.regDt }}</span>
              </div>
              <div class="td" style="--tb-width: 6%"></div>
            </div>
            <!-- // D: PC 전용 -->
            <!-- D: MO 전용 -->
            <div class="only-mo">
              <div class="td">
                <span
                  v-if="item.pntSeCd == 'WATER'"
                  class="c-flag type-mising type-red"
                >
                  <b>{{ item.prdctSeNm }}-{{ item.pntSeNm }}</b>
                </span>
                <span
                  v-if="item.pntSeCd == 'OIL'"
                  class="c-flag type-mising type-yellow"
                >
                  <b>{{ item.prdctSeNm }}-{{ item.pntSeNm }}</b>
                </span>
                <span
                  v-if="item.pntSeCd == 'COMPLEX'"
                  class="c-flag type-mising type-purple"
                >
                  <b>{{ item.prdctSeNm }}-{{ item.pntSeNm }}</b>
                </span>
                <span class="answer-status">
                  <span
                    :class="
                      item.ansRemarkCn != null
                        ? 'c-flag type-answer type-primary'
                        : 'c-flag type-answer type-gray'
                    "
                    >{{
                      item.ansRemarkCn != null ? "답변완료" : "답변대기"
                    }}</span
                  >
                </span>
                <span class="c-flag type-answer type-delete" v-if="item.ansRemarkCn== null && !data.tabType" 
                @click.stop="
                btnCmd('expendClick', {
                  index: idx,
                  baseCd: item.baseCd,
                  combnCrtrVol: item.combnCrtrVol,
                  pntSn: item.pntSn,
                  spcfctCd: item.spcfctCd,
                  combnCrcolnQstnSn: item.combnCrcolnQstnSn,
                  ansRemarkCn: item.ansRemarkCn,
                  clickType: 'list-delete',
                })
              "
                >문의삭제</span>
              </div>
              <div class="td">
                <strong class="name">{{ item.prdctNm }}</strong>
              </div>
              <div class="td">
                <span class="color-name">{{ cmUtil.sanitizeHTML2(item.colorNm) }}</span>
              </div>
              <div class="td">
                <span class="info"
                  >{{ item.baseNm }}/{{ item.shineTypeNm }}/{{
                    item.spcfctNm
                  }}</span
                >
              </div>
              <div class="td">
                <span class="date">등록일: {{ item.regDt }}</span>
              </div>
            </div>
          </button>
          <div
            :id="'act' + idx"
            class="accordion-content"
            data-accordion-content
            :aria-hidden="data.colorCombin.expendIndex !== idx"
          >
            <!-- D: 프린트 영역에서만 나타남 -->
            <strong class="print-title">문의내용</strong>
            <div class="required-notice-box">
              <span class="title">배합 필수 확인사항</span>
              <ul class="c-dot-list">
                <li>
                  첫 번째 조색 제품의 색상과 의뢰받으신 색상을 반드시 확인하신
                  후 나머지 도료의 조색을 진행하시기 바랍니다.
                </li>
                <li>
                  의뢰하신 색상 및 베이스 도료에 따라 해당하는 내용(주의사항)이
                  비고란에 기재되어 있으니 반드시 확인하시고 조색하시기
                  바랍니다.
                </li>
                <li>
                  동일한 색상의 경우 시중품과 자동조색 색상은 차이가 발생할 수
                  있습니다.
                </li>
              </ul>
            </div>
            <div class="print-head">
              <span class="date">등록일: {{ item.regDt }}</span>
              <strong class="title"
                >{{ item.prdctSeNm }}-{{ item.pntSeNm }}/{{
                  item.prdctNm
                }}</strong
              >
              <span class="info"
                >{{ item.shineTypeNm }}/{{ cmUtil.sanitizeHTML2(item.colorNm) }}/{{
                  item.spcfctNm
                }}</span
              >
            </div>
            <!-- // D: 프린트 영역에서만 나타남 -->
            <!-- D: 문의내용 -->
            <div class="inquiry-content" v-html="sanitizeHTML(item.qstnCn)" />
            <!-- // D: 문의내용 -->
            <!-- D: 답변 -->
            <div class="answer-content">
              <span class="label">[답변]</span>
              <div class="c-table-horizontal">
                <table>
                  <caption>
                    배합 확인 테이블
                  </caption>
                  <colgroup>
                    <col style="width: 120px" />
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th scope="row">NO (글번호)</th>
                      <td>{{ item.combnCrcolnQstnSn }}</td>
                    </tr>
                    <tr>
                      <th scope="row">제품명</th>
                      <td>{{ item.prdctNm }}</td>
                    </tr>
                    <tr>
                      <th scope="row">일반/팬톤</th>
                      <td>{{ item.prdctSeNm }}</td>
                    </tr>
                    <tr>
                       <th scope="row">컬러북</th> 
                       <td><div v-html="sanitizeHTML(item.colorBookNm)" /></td>
                    </tr>
                    <tr>
                      <th scope="row">색상명</th>
                      <td>{{ cmUtil.sanitizeHTML2(item.colorNm) }}</td>
                    </tr>
                    <tr>
                      <th scope="row">베이스</th>
                      <td>
                        {{ item.baseNm }}
                        <!-- MEMO: 오픈이후 주석해제
                        <div class="c-btn-area type-mixing">
                          <button
                            type="button"
                            class="c-util-button type-line-black type-small"
                            :disabled="item.baseCd == 'W' ? false : true"
                            @click="btnCmd('baske', {})"
                          >
                            <span>장바구니에 추가</span>
                          </button>
                        </div>
                        -->
                      </td>
                    </tr>
                    <tr>
                       <th scope="row">광택</th> 
                       <td><div v-html="sanitizeHTML(item.shineTypeNm)" /></td>
                    </tr>
                    <tr v-if="item.oldYn != 'Y'">
                      <th scope="row">규격</th>
                      <td v-if="item.baseNm != '기타'">
                        <div class="c-filter-box type-non-line">
                          <div class="c-check-field">
                            <div
                              class="c-radio type-small"
                              v-for="(code, num) in data.colorCombin.SpcfctList[
                                idx
                              ]"
                              :key="num"
                            >
                              <input
                                type="radio"
                                :id="'standard-raido' + idx + '-' + num"
                                :name="'standard-group' + idx"
                                :value="code.spcfctCd"
                                v-model="data.colorCombin.chkSpcfct[idx]"
                                :checked="item.spcfctCd === code.spcfctCd"
                              />
                              <label
                                :for="'standard-raido' + idx + '-' + num"
                                >{{ code.spcfctNm }}</label
                              >
                            </div>
                          </div>
                          <button
                            type="button"
                            class="c-util-button type-line-black type-small"
                            @click="
                              btnCmd('colorSearch', {
                                index: idx,
                                baseCd: item.baseCd,
                                combnCrtrVol: item.combnCrtrVol,
                                pntSn: item.pntSn,
                                spcfctCd: data.colorCombin.chkSpcfct[idx],
                                combnCrcolnQstnSn: item.combnCrcolnQstnSn,
                              })
                            "
                          >
                            <span>조회</span>
                          </button>
                        </div>
                      </td>
                      <td v-else>
                        {{ item.spcfctNm }}
                      </td>
                    </tr>
                    <tr v-else>
                      <th scope="row">규격</th>
                      <td>{{ item.spcfctInputCn }}</td>
                    </tr>
                    <tr v-if="item.baseNm != '기타'">
                      <th scope="row">색상배합</th>
                      <td>
                        <div class="color-mixing-list">
                          <ul>
                            <li
                              v-for="(list, i) in data.colorCombin.combnVolList[
                                idx
                              ]"
                              :key="i"
                            >
                              <span>{{ list.clrntNm }}</span>
                              <span>{{ list.inputCombnVol }}</span>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">비고</th>
                      <td><div v-html="sanitizeHTML(item.ansRemarkCn)" /></td>
                    </tr>
                    <tr>
                      <th scope="row">작성자</th>
                      <td>{{ item.answrNm }}(작성일자: {{ item.mdfcnDt }})</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- D: PC 전용 -->
              <div class="c-btn-area flex-ar has-print">
                <button
                  type="button"
                  class="c-util-button type-secondary"
                  @click="
                    handlePrint({
                      index: idx,
                      baseCd: item.baseCd,
                      combnCrtrVol: item.combnCrtrVol,
                      pntSn: item.pntSn,
                      spcfctCd: item.spcfctCd,
                      combnCrcolnQstnSn: item.combnCrcolnQstnSn,
                    })
                  "
                >
                  <span>프린트</span>
                </button>
              </div>
              <!-- // D: PC 전용 -->
            </div>
            <!-- // D: 답변 -->
          </div>
        </div>
        <!-- // D: 답변 등록전(button에 disabled추가+토스트팝업 활성화 is-active 클래스 추가) -->
      </div>
    </div>

    <!-- // D: 문의 검색 목록 -->

    <!-- D : pageing area -->
    <Pagination
      ref="paginationEl"
      v-if="!data.colorCombin.list || data.colorCombin.list.length > 0"
      :total-pages="data.colorCombin.totalPage"
      :per-page="data.colorCombin.limit"
      :show-select="true"
      :page-reload-flag="data.colorCombin.pageReloadFlag"
      @page-change="handlePageChange"
      @items-per-page-change="handleItemsPerPageChange"
    />
    <!-- // D : pageing area -->

    <!-- D: no data -->
    <div v-if="data.colorCombin.list <= 0" class="c-no-data-box">
      <div class="icon-box">
        <i class="c-icon icon-nodata size-large"></i>
      </div>
      <p class="text">조회 결과가 없습니다.</p>
    </div>
  </div>
</template>
<script setup name="coloCombinInqTab">
import {
  onMounted,
  reactive,
  inject,
  ref,
  computed,
  onBeforeUnmount,
  watch,
  nextTick,
} from "vue";
import { popoverTrigger } from "@/js/_ui";
import { useRouter, useRoute } from "vue-router";
import { api } from "@/plugins/api";
import { throttle } from "lodash";

import Pagination from "@/components/paintpro/base/pagination.vue";

import * as cmUtil from "@/utils/cmUtil.js";
import $ from "jquery";

const { isMobile } = cmUtil.useDeviceType();
const url = inject("url_prefix");
const router = useRouter();
const route = useRoute();
const startDatepickerRef = ref(null);
const endDatepickerRef = ref(null);
const paginationEl = ref(null);

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    deviceType: isMobile.value ? "M" : "P",
  },
  // 제품명(수성, 유성) selectBox Lsit
  selectBox: {
    list: [],
  },
  // 컬러북 회사 selectBox Lsit
  selectColorbookBox1: {
    list: [],
  },
  // 전체문의,MY배합 탭
  tabType: true,
  //문의리스트
  colorCombin: {
    flag: false,
    expendIndex: -1, //아코디언 index
    list: [],
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    pageReloadFlag: 0,
    loading: false,
    //조회조건
    search: {
      tabType: null,
      pntSeCd: null, //수성,유성
      prdctSeCd: null, //제품구분(일반,팬톤)
      startRegDt: "",
      endRegDt: "",
      chcPrdctSn: null,
      searchKeyword: null,
      prdctNm : "",       //제품명
      shineTypeNm : "",   //광택
      colorBookNm : "",   //컬러북
      colorNm : "",       //컬러명
      cybSeqNo : "",      //글번호
      rgtr  : ""          //작성자
    },
    init_search: {
      pntSeCd: "", //수성,유성
      prdctSeCd: "", //제품구분(일반,팬톤)
      chcPrdctSn: null,
      searchKeyword: null,
    },
    chkPrdct: {}, //선택한 제품
    chkDate: "",
    chkSpcfct: [], // 색상배합
    combnVolList: [], // 답변완료 > 색상배합 리스트
    SpcfctList: [], // 답변완료 > 규격
    popover: false,
    allStartDate: null,
  },
  route: {
    combnCrcolnQstnSn: 0,
  },
});

/**********************
 * 탭 활성화 처리
 *********************/
const tabActive = (event) => {
  const tabInfo = event.target.id;

  if (tabInfo == "tabType") {
    data.tabType = true;
    data.colorCombin.limit = 100;
    data.colorCombin.search.tabType = null;
    searchCmd("search");
    data.colorCombin.pageReloadFlag++;
  } else {
    data.tabType = false;
    data.colorCombin.search.tabType = "my";
    searchCmd("search");
  }
};

// 오늘 날짜
const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

// script 태그와 이벤트 핸들러 제거
function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}

const datePair = computed(() => [
  data.colorCombin.search.startRegDt,
  data.colorCombin.search.endRegDt,
]);

// 검색기간 시작일, 종료일 체크
watch(
  datePair,
  async ([newStartDate, newEndDate], [oldStartDate, oldEndDate]) => {
    const start = new Date(newStartDate);
    const end = new Date(newEndDate);
    if (end < start) {
      data.colorCombin.search.startRegDt = oldStartDate;
      data.colorCombin.search.endRegDt = oldEndDate;
      await cmUtil.alert(
        "종료일을 시작일보다 이전으로 설정할 수 없습니다.</br> 다시 확인해주세요."
      );
    }
  }
);

watch(
  () => route.params.id,
  async (newValue) => {
    data.colorCombin.expendIndex = -1;
    data.route.combnCrcolnQstnSn = newValue;
    data.tabType = false;
    data.colorCombin.search.tabType = "my";
    data.colorCombin.limit = 100;
    await searchCmd("search");
    goToSelectedPost();
    await loadReplData(route.params.id);
    data.colorCombin.pageReloadFlag++;
  }
);

/**********************
 * 마운트
 *********************/
onMounted(async () => {
  jqueryDatepicker(); // 달력
  pageInit(); // 초기셋팅
  popoverTrigger(); // 팝오버

  if (route.params.id) {
    data.route.combnCrcolnQstnSn = route.params.id;
    data.colorCombin.limit = 100;
    data.tabType = false;
    data.colorCombin.search.tabType = "my";
    await searchCmd("search");
    data.colorCombin.pageReloadFlag++;
    goToSelectedPost();
    await loadReplData(route.params.id);
  } else {
    searchCmd("search");
  }
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  searchCmd("radio01Chk");
  await dateCalculation("ALL");
 

  // 스크롤 이벤트 등록
  if (data.page.deviceType == "M") {
    document.addEventListener("scroll", handleScroll);
  }
}

/**********************
 * 리셋 모음
 *********************/
async function resetCmd(cmd = "") {
  if (cmd === "reset") {
    data.colorCombin.search = { ...data.colorCombin.init_search };
    data.colorCombin.chkDate = "ALL";
    await dateCalculation("ALL");
  } else if (cmd === "keyword") {
    data.colorCombin.search.searchKeyword = null;
  }
}


// async function colorbookList(){
//       const res = await api.post(`${url}/colorCombin/selectColorbookProd`, {});

//     data.selectColorbookBox1.list = res.data;
// }

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", params = {}) {
  //data.colorCombin.loading = true;

  // 일반/팬톤 radio 선택 시
  if (cmd === "radio01Chk") {
    data.colorCombin.search.chcPrdctSn = null;
    const res = await api.post(`${url}/colorCombin/selectBox01`, {
      pntSeCd: data.colorCombin.search.pntSeCd,
      prdctSeCd: params.type,
    });

    data.selectBox.list = res.data;
  }
  // 제품명(수성/유성) radio 선택 시
  else if (cmd === "radio02Chk") {
    data.colorCombin.search.chcPrdctSn = null;
    const res = await api.post(`${url}/colorCombin/selectBox01`, {
      pntSeCd: params.type,
      prdctSeCd: data.colorCombin.search.prdctSeCd,
    });

    data.selectBox.list = res.data;
  }
  //조회
  else if (cmd === "search") {
    const res = await api.post(`${url}/colorCombin/selectColor01`, {
      ...data.colorCombin.search,
      page: params["page"] || 1,
      limit: params["limit"] || data.colorCombin.limit,
    });
    if (params["page"] == null || params["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }

    if(res.data.totalCount > 0){
      if(res.data.list[0].cybYn=="Y"){
        data.colorCombin.flag = true;
      }else{
        data.colorCombin.flag = false;
      }
    }

    data.colorCombin.list = res.data.list;
    data.colorCombin.page = params["page"] || 1;
    data.colorCombin.totalCount = res.data.totalCount;
    data.colorCombin.totalPage = data.colorCombin.totalCount
      ? Math.ceil(data.colorCombin.totalCount / data.colorCombin.limit)
      : 0;

    data.colorCombin.expendIndex = -1;
    if (data.route.combnCrcolnQstnSn > 0) {
      for (let i in res.data.list) {
        if (
          res.data.list[i].combnCrcolnQstnSn == data.route.combnCrcolnQstnSn
        ) {
          data.colorCombin.expendIndex = Number(i);
          break;
        }
      }
    }
  }
  // 모바일 조회
  else if (cmd === "scrollSearch") {
    const res = await api.post(`${url}/colorCombin/selectColor01`, {
      ...data.colorCombin.search,
      page: params["page"] || 1,
      limit: params["limit"] || data.colorCombin.limit,
    });

    data.colorCombin.list.push(...res.data.list);
    data.colorCombin.page = params["page"] || 1;
    data.colorCombin.totalCount = res.data.totalCount;
    data.colorCombin.totalPage = data.colorCombin.totalCount
      ? Math.ceil(data.colorCombin.totalCount / data.colorCombin.limit)
      : 0;

    data.colorCombin.expendIndex = -1;
  }

  await btnCmd("expendClick", { index: -1, clickType: "search" });
  // data.colorCombin.loading = false;
}

/**********************
 * 페이징 모음
 *********************/
function handlePageChange(page) {
  data.colorCombin.expendIndex = -1;
  searchCmd("search", { page: page });
}
function handleItemsPerPageChange(perPage) {
  data.colorCombin.expendIndex = -1;
  data.colorCombin.limit = perPage;
  searchCmd("search", {});
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", params = {}) {
  // 조색배합 아코디언 활성화
  if (cmd === "expendClick") {
    //등록된 답변이 있는 경우(답변완료)
    if (params.ansRemarkCn != null) {
      if (data.colorCombin.expendIndex == params.index) {
        data.colorCombin.expendIndex = -1;
      } else {
        data.colorCombin.expendIndex = params.index;
      }
      // 아코디언 닫을때 기본 값으로 재 조회 및 radio checked
      data.colorCombin.chkSpcfct[params.index] = params.spcfctCd;

      // 규격 + 색상배합 조회
      const resSpcfct = await api.post(`${url}/colorCombin/selectBox03`, {
        pntSn: params.pntSn,
      });
      data.colorCombin.SpcfctList[params.index] = resSpcfct.data;

      const res = await api.post(
        `${url}/colorCombin/selectCombnVolList`,
        params
      );
      data.colorCombin.combnVolList[params.index] = res.data.filter(
        (item) => item.inputCombnVol != 0
      );
    } else if (params.clickType == "list" && params.ansRemarkCn== null && params.clickType !== "list-delete") {
      cmUtil.toast("답변 등록 전입니다.");
      return;
    } else if (params.clickType == "list-delete") {
      if (!(await cmUtil.confirm("요청하신 배합문의를 삭제합니다 문의 글은 다시 확인이 불가합니다 삭제하시겠습니까?"))) {
        return false;
      }
      const res = await api.post(
        `${url}/colorCombin/updateMyCombinMngYn`,
        params
      );
      if (res.resultCode == 200) {
        
          await cmUtil.alert(            
              "배합문의가 삭제되었습니다."
          );
          data.colorCombin.search.tabType = "my";
          searchCmd("search");

      }
    }
  }
  // 조색배합 검색 우측 버튼
  else if (cmd === "popover") {
    data.popover = !data.popover;
  }
  // 조색배합 답변 > 색상배합 조회
  else if (cmd === "colorSearch") {
    //규격
    const resSpcfct = await api.post(`${url}/colorCombin/selectBox03`, {
      pntSn: params.pntSn,
    });
    data.colorCombin.SpcfctList[params.index] = resSpcfct.data;

    const res = await api.post(`${url}/colorCombin/selectCombnVolList`, params);
    let list = res.data.filter((item) => item.inputCombnVol != 0);
    if (list && list.length > 0) {
      data.colorCombin.combnVolList[params.index] = list;
    }
  }
}

/**********************
 * 배합문의로 이동
 *********************/
async function moveToCombinInqTab() {
  const res = await api.post(`${url}/colorCombin/selectHldyCount`, {});

  if (res.data == 0) {
    router.push({
      name: "/paintpro/colorCombinmixedInq",
    });
  } else {
    await cmUtil.alert(
      "배합문의는 평일에 이용이 가능합니다. (토요일, 공휴일 제외)"
    );
  }
}

/**********************
 * 문의/답변 프린트
 *********************/
async function handlePrint(params) {
  if (typeof window !== "undefined") {
    // 문의했던 규격의 색상배합으로 조회 처리
    data.colorCombin.chkSpcfct[params.index] = params.spcfctCd;
    await btnCmd("colorSearch", params);
    window.print();
  }
}

/**********************
 * jquery 달력
 *********************/
async function jqueryDatepicker() {
  if (startDatepickerRef.value == null) return;
  $(startDatepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: "-1D",
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.colorCombin.search.startRegDt = dateText;
      data.colorCombin.chkDate = "";
    },
  });

  // 종료일
  if (endDatepickerRef.value == null) return;
  $(endDatepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: "0D",
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.colorCombin.search.endRegDt = dateText;
      data.colorCombin.chkDate = "";
    },
  });
}

/**********************
 * 등록일 버튼 모음
 *********************/
async function dateCalculation(period) {
  const today = new Date();
  let resultDate = new Date(today);

  switch (period) {
    case "ALL":
      break;
    case "1M":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "6M":
      resultDate.setDate(today.getDate() - 179);
      break;
    case "1Y":
      resultDate.setDate(today.getDate() - 364);
      break;
    default:
      await cmUtil.alert("알 수 없는 기간입니다.");
      return null;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  resultDate = resultDate.toLocaleDateString("en-CA", options);

  if (period == "ALL") {
    data.colorCombin.search.startRegDt = null;
    data.colorCombin.search.endRegDt = null;
  } else {
    data.colorCombin.search.startRegDt = resultDate;
    data.colorCombin.search.endRegDt = todayDate.value;
  }

  data.colorCombin.chkDate = period;
}

// 아코디언 열린 위치로 스크롤 이동
const goToSelectedPost = () => {
  nextTick(() => {
    const id = route.params.id || "";
    if (id) {
      const idEl = document.getElementById(`ID${id}`);
      let positionTop = idEl?.getBoundingClientRect().top || 0;
      if (positionTop > 100) {
        positionTop -= 95;
      }
      window.scroll({ top: positionTop });
    }
  });
};

/**********************
 * 모바일 scroll 조회
 *********************/
const handleScroll = throttle(() => {
  if (
    data.page.deviceType != "M" ||
    data.colorCombin.loading ||
    data.colorCombin.list.length === 0
  ) {
    return;
  }
  data.colorCombin.loading = true;

  const scrollPosition = window.innerHeight + window.scrollY;
  const bottom = document.documentElement.scrollHeight;

  if (scrollPosition >= bottom - 350) {
    searchCmd("scrollSearch", { page: data.colorCombin.page + 1 });
  }
  data.colorCombin.loading = false;
}, 300);

onBeforeUnmount(() => {
  document.removeEventListener("scroll", handleScroll);
});

// 답변 상세데이타 조회
const loadReplData = async (_id = 0) => {
  let idx = -1;
  let params = {};
  for (let i = 0; i < data.colorCombin.list.length; i++) {
    let item = data.colorCombin.list[i];
    if (_id == item.combnCrcolnQstnSn) {
      idx = i;
      params = {
        index: i,
        baseCd: item.baseCd,
        combnCrtrVol: item.combnCrtrVol,
        pntSn: item.pntSn,
        spcfctCd: item.spcfctCd,
        combnCrcolnQstnSn: item.combnCrcolnQstnSn,
        ansRemarkCn: item.ansRemarkCn,
        clickType: "list",
      };

      break;
    }
  }
  if (idx > -1) {
    const resSpcfct = await api.post(`${url}/colorCombin/selectBox03`, {
      pntSn: params.pntSn,
    });
    data.colorCombin.SpcfctList[idx] = resSpcfct.data;

    const res = await api.post(`${url}/colorCombin/selectCombnVolList`, params);
    data.colorCombin.combnVolList[idx] = res.data.filter(
      (item) => item.inputCombnVol != 0
    );
  }
};
</script>

<style>
.alert .dialog {
  max-width: 280px !important;
      }
</style>
